import { render, staticRenderFns } from "./PosterPreview.vue?vue&type=template&id=0984e9c6&scoped=true"
import script from "./PosterPreview.vue?vue&type=script&lang=js"
export * from "./PosterPreview.vue?vue&type=script&lang=js"
import style0 from "./PosterPreview.vue?vue&type=style&index=0&id=0984e9c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0984e9c6",
  null
  
)

export default component.exports